module.exports = __webpack_public_path__ + "img/american-express.19476c1a.png";